import React, { useState } from "react";
import { calc } from "../../../js/chips-common";
import "../../../assets/fonts/font.css";
let interval;
let intervalMs;

export function WinnersDisplay({ winners }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (interval) {
    clearInterval(interval);
  }

  function normalizedIntervalMs() {
    const duration = intervalMs && currentIndex === 0 ? 300 : 2300;
    if (intervalMs) {
      const offset = Date.now() - intervalMs;
      if (duration > offset) {
        return duration - offset;
      }
    }
    return duration;
  }

  interval = setInterval(() => {
    setCurrentIndex((currentIndex + 1) % (winners.length + 1));
    intervalMs = Date.now();
  }, normalizedIntervalMs());

  const winnersClone = [...winners];
  winnersClone.push(winnersClone[0]);
  return (
    <div
      className="scrollbar-hidden"
      style={{
        marginTop: calc(10),
        width: calc(328),
        height: calc(48),
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        background: "#FFE6B5",
        overflow: "hidden",
        whiteSpace: "nowrap",
        borderRadius: calc(10),
      }}
    >
      {winnersClone.map((winner, index) => (
        <div
          key={`winner-${index}-${winner.uid}`}
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            minHeight: calc(48),
            transitionProperty: "all",
            transition: currentIndex === 0 ? "none" : ".3s ease-in-out",
            transform: `translateY(${calc(-48 * currentIndex)})`,
          }}
        >
          <img
            style={{
              width: calc(32),
              height: calc(32),
            }}
            src={winner.prize_image_url}
          />

          <span
            style={{
              color: "#3D3D3D",
              fontFamily: "Spoqa Han Sans Neo",
              fontSize: calc(14),
              fontStyle: "normal",
              fontWeight: "500",
              lineHeight: "150%",
            }}
            dangerouslySetInnerHTML={{ __html: winner.message }}
          ></span>
        </div>
      ))}
    </div>
  );
}
